<script>
    export default {
        props: {
            answer: {
                type: Boolean,
                default: false,
            },
            id: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                default: '',
            },
            text: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                show: false,
            };
        },
    };
</script>

<template>
    <div class="dropdown"
         @mouseenter="show = true"
         @mouseleave="show = false">
        <div :class="['dropdown-trigger', answer ? 'dropdown-trigger--answer' : '']"
             aria-haspopup="true"
             :aria-controls="`dropdown-${id}`">
            <span class="icon" tabindex="0">
                <i class="fa fa-info-circle"></i>
            </span>
        </div>
        <transition name="transition-zoom-fade">
            <div v-if="show"
                 :class="['dropdown-menu', {'dropdown-menu--answer': answer }]"
                 :id="`dropdown-${id}`"
                 role="tooltip">
                <div class="dropdown-content">
                    <div class="dropdown-item">
                        <h4 class="title">
                            <span class="icon"><i class="fa fa-info-circle"></i></span>
                            <span v-if="title">{{ title }}</span>
                        </h4>
                        <div v-if="text"
                             v-html="text"
                             class="rte"></div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>
